/* eslint-disable @typescript-eslint/no-non-null-assertion */
import React, { useState } from "react";
import { IonContent, IonButton, IonInput, IonIcon } from "@ionic/react";
import { chevronBack } from "ionicons/icons";
import { PhoneFormatter } from "../../ui/PhoneFormate";
import OtpPopup from "../../ui/popups/OtpPopup";
import analytics from "../../../services/firebaseAnalytics";

interface UserInfoProps {
  closeModal: () => void;
  nextStep: () => void;
  prevStep?: () => void;
  steps?: any[];
  currentStep: number;
  first_name: string;
  setFirstName: (value: string) => void;
  last_name: string;
  setLastName: (value: string) => void;
  countryCode: string;
  setCountryCode: (value: string) => void;
  email: string;
  setEmail: (value: string) => void;
  phone: string;
  setPhone: (value: string) => void;
  user: any;
}

export const UserInfo: React.FC<UserInfoProps> = ({
  closeModal,
  nextStep,
  prevStep,
  steps,
  currentStep,
  first_name,
  setFirstName,
  last_name,
  setLastName,
  countryCode,
  setCountryCode,
  email,
  setEmail,
  phone,
  setPhone,
  user,
}) => {
  const handleSkipSetup = () => {
    closeModal();
  };

  const removeSpaces = (phoneNumber: string): string => {
    return phoneNumber.replace(/\s/g, "");
  };

  const handleNext = () => {
    if (shouldShowPhone && removeSpaces(newPhone) !== removeSpaces(phone)) {
      setMode("phone");
      setOtpModal(true);
      return;
    }
    if (shouldShowEmail && removeSpaces(newEmail) !== removeSpaces(email)) {
      setMode("email");
      setOtpModal(true);
      return;
    }
    nextStep();
  };

  const handleBack = () => {
    if (prevStep) {
      prevStep();
    }
  };

  const CloseModal = () => {
    setOtpModal(false);
  };

  const [OtpModal, setOtpModal] = React.useState(false);
  const [mode, setMode] = React.useState<"phone" | "email">("email");
  const [newPhone, setNewPhone] = React.useState<string>(phone);
  const [newEmail, setNewEmail] = React.useState<string>(email);

  const [, setIsFormated] = useState<boolean>(false);
  const [isCodeModalBlur, setIsCodeModalBlur] = useState(false);

  const shouldShowPhone = false;
  const shouldShowEmail = false;

  // Keyboard detection state
  const [isKeyboardOpen, setIsKeyboardOpen] = React.useState(false);

  React.useEffect(() => {
    const trackInfoScreenView = async () => {
      await analytics.logEvent("onboarding_user_info_viewed", {});
    };
    trackInfoScreenView();
    const handleResize = () => {
      if (window.visualViewport) {
        // If the viewport height is reduced by more than 100px, assume keyboard is open
        setIsKeyboardOpen(
          window.innerHeight - window.visualViewport.height > 100
        );
      }
    };
    if (window.visualViewport) {
      window.visualViewport.addEventListener("resize", handleResize);
    }
    return () => {
      if (window.visualViewport) {
        window.visualViewport.removeEventListener("resize", handleResize);
      }
    };
  }, []);

  return (
    <IonContent className="ion-padding onboarding-section">
      <div
        className="user-info-blur-wrapper"
        style={{
          filter: OtpModal || isCodeModalBlur ? "blur(6px)" : "none",
          transition: "filter 0.3s",
        }}
      >
        <div className="navigation-header">
          <button className="back-text-button flex" onClick={handleBack}>
            <IonIcon icon={chevronBack} className="back-icon " />
            <span>Back</span>
          </button>
          <button className="skip-setup-button" onClick={handleSkipSetup}>
            Skip Setup
          </button>
        </div>

        <div className="onboarding-section">
          <h1 className="form-title">Let&rsquo;s get to know you</h1>

          <div className="input-fields">
            <div
              className="last-name-input"
              style={{
                gap: "5px",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <IonInput
                maxlength={40}
                className="custom-input"
                placeholder="First Name"
                value={first_name}
                onIonInput={(e) => {
                  const value = e.detail.value || "";
                  setFirstName(value.charAt(0).toUpperCase() + value.slice(1));
                }}
              />
              {first_name.length >= 40 && (
                <p
                  className="input-info"
                  style={{
                    color: "red",
                    fontSize: "12px",
                    paddingLeft: "10px",
                    fontFamily: "FigTree",
                  }}
                >
                  First name should be of maximum 40 characters
                </p>
              )}
            </div>
            <div
              className="last-name-input"
              style={{
                gap: "5px",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <IonInput
                maxlength={40}
                className="custom-input"
                placeholder="Last Name"
                value={last_name}
                onIonInput={(e) => {
                  const value = e.detail.value || "";
                  setLastName(value.charAt(0).toUpperCase() + value.slice(1));
                }}
              />
              {last_name.length >= 40 && (
                <p
                  className="input-info"
                  style={{
                    color: "red",
                    fontSize: "12px",
                    paddingLeft: "10px",
                    fontFamily: "FigTree",
                  }}
                >
                  Last name should be of maximum 40 characters
                </p>
              )}
            </div>
            {shouldShowPhone && (
              <PhoneFormatter
                CountryCode={countryCode ? countryCode : "+1"}
                setIsFormated={setIsFormated}
                setPopup={setOtpModal}
                isCodeModalOpen={setIsCodeModalBlur}
                setCountryCode={(value) => setCountryCode(value)}
                phone={newPhone.replace(/^\+\d+\s?/, "")}
                setPhone={setNewPhone}
                handlePhoneInput={() => {
                  // handleContactChange(value);
                }}
                // Removed onBlur prop - OTP will now trigger on Next button click
              />
            )}

            {shouldShowEmail && (
              <IonInput
                className="custom-input"
                placeholder="Email Address"
                value={newEmail}
                // Removed onIonBlur - OTP will now trigger on Next button click
                onIonInput={(e) => {
                  const value = e.detail.value || "";
                  setNewEmail(value);
                }}
                type="email"
              />
            )}
          </div>
        </div>

        <div className="progress-indicator">
          {steps?.map((_, index) => (
            <div
              key={index}
              className={`progress-dot ${
                currentStep === index ? "active" : ""
              }`}
            />
          ))}
        </div>

        {/* Move Next button above keyboard when open */}
        <div
          className={`button-stack-container flex flex-col${
            isKeyboardOpen ? " keyboard-open" : ""
          }`}
          style={
            isKeyboardOpen
              ? {
                  position: "fixed",
                  left: 0,
                  right: 0,
                  bottom: window.visualViewport
                    ? window.visualViewport.height - 56
                    : 0, // 56px is typical button height
                  zIndex: 1000,
                  background: "#fff",
                  padding: "16px",
                  boxShadow: "0 -2px 8px rgba(0,0,0,0.05)",
                  transition: "bottom 0.2s",
                }
              : {}
          }
        >
          <IonButton
            expand="block"
            className="primary-button"
            onClick={handleNext}
            disabled={first_name.length >= 40 || last_name.length >= 40}
          >
            Next
          </IonButton>
          <button className="skip-link" onClick={handleSkipSetup}>
            {/* Skip Setup */}
          </button>
        </div>

        {mode === "phone" && OtpModal && (
          <OtpPopup
            isOpen={OtpModal}
            onClose={() => {
              setNewPhone(phone);
              setNewEmail(email);
              CloseModal();
            }}
            phone={newPhone}
            setPhone={(val: string) => setNewPhone(val)}
            email={email}
            countryCode={countryCode ? countryCode : "+1"}
            setCountryCode={(val: string) => setCountryCode(val)}
            setEmail={(val: string) => setNewEmail(val)}
            userPhone={phone}
            userEmail={email}
            handleSaveProfile={(contact: string, type: "phone" | "email") => {
              if (type === "phone") {
                setPhone(contact);
                nextStep();
              }
            }}
            showToastMessage={() => {
              console.log(`Your ${mode} has been updated successfully`);
            }}
            mode="phone"
          />
        )}
        {mode === "email" && OtpModal && (
          <OtpPopup
            isOpen={OtpModal}
            onClose={() => {
              setNewPhone(phone);
              setNewEmail(email);
              CloseModal();
            }}
            phone={newPhone}
            setPhone={setNewPhone}
            email={newEmail}
            setEmail={setNewEmail}
            countryCode={countryCode || "+1"}
            setCountryCode={(val: string) => setCountryCode(val)}
            userPhone={phone}
            userEmail={email}
            handleSaveProfile={(contact: string, type: "phone" | "email") => {
              if (type === "email") {
                setEmail(contact);
                nextStep();
              }
            }}
            showToastMessage={() => {
              console.log(`Your ${mode} has been updated successfully`);
            }}
            mode="email"
          />
        )}
      </div>
    </IonContent>
  );
};
